// Gallery videos. The gallery page shows a "Videos" tab as soon as this list has an entry.
//
// Self-hosted file (put it in /public/videos):
//   {src: "/videos/pivot-door.mp4", poster: "/videos/pivot-door.jpg", title: "Timber pivot door", category: "pivot-doors"}
//
// YouTube / Vimeo (use the embed URL):
//   {embed: "https://www.youtube.com/embed/VIDEO_ID", poster: "/videos/thumb.jpg", title: "Alfresco enclosure", category: "sliding-doors"}
//
// `category` is optional and must match a category `path` in catalog.js so the category filter can find it.
// `poster` is optional; without it the tile shows a plain play button.
export const galleryVideos = [
    {src: "/videos/timber-bifold-laundry.mp4", poster: "/videos/timber-bifold-laundry.jpg", title: "Timber bi fold doors concealing a laundry", category: "bifold-doors"},
    {src: "/videos/sliding-security-screen-door.mp4", poster: "/videos/sliding-security-screen-door.jpg", title: "Sliding security screen door", category: "security-oneway-doors"},
];
